<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="takeOrderImageDialog"
        persistent
        max-width="530px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Order Image</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout
                  row
                  wrap
                >
                  <v-flex
                    xs12
                    sm12
                    md12
                    lg5
                    class="web-camera-container"
                  >
                    <div class="camera-button">
                      <v-btn
                        style="height:auto; margin-right: 4%"
                        outline
                        color="success"
                        @click="toggleCamera"
                      ><span v-if="!isCameraOpen">Open Camera</span>
                        <span v-else>Close Camera</span>
                      </v-btn>
                      <v-btn
                        v-if="isCameraOpen"
                        style="height:auto"
                        outline
                        color="primary"
                        @click="flipCamera"
                      >Flip Camera</v-btn>
                    </div>

                    <div
                      v-if="isCameraOpen"
                      v-show="!isLoading"
                      class="camera-box"
                      :class="{ 'flash' : isShotPhoto }"
                      style="overflow: hidden; width: 450px; height: 337.5px;"
                    >
                      <div
                        class="camera-shutter"
                        :class="{'flash' : isShotPhoto}"
                      ></div>

                      <video
                        v-show="!isPhotoTaken"
                        ref="camera"
                        :width="450"
                        :height="337.5"
                        autoplay
                        :style="{ transform: `scale(${zoom})` }"
                      ></video>
                      <canvas
                        v-show="isPhotoTaken"
                        id="photoTaken"
                        ref="canvas"
                        :width="450"
                        :height="337.5"
                      ></canvas>
                    </div>

                    <div
                      v-if="isCameraOpen && !isLoading"
                      class="camera-zoom"
                    >
                      <div class="d-flex align-items-center" style="width: 100%; padding: 0 1rem;">
                        <v-slider
                          v-model="zoom"
                          :min="1"
                          :max="3"
                          :step="0.1"
                          thumb-label
                          style="flex: 1;"
                        ></v-slider>
                      </div>
                    </div>

                    <div
                      v-if="isCameraOpen && !isLoading"
                      class="camera-shoot"
                    >
                      <button
                        type="button"
                        class="button"
                        @click="takePhoto"
                      >
                        <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
                      </button>
                    </div>

                    <div
                      v-if="isPhotoTaken && isCameraOpen"
                      class="camera-download"
                    >
                      <a
                        id="downloadPhoto"
                        :download="`Order #${oid}.jpg`"
                        class="button"
                        role="button"
                        @click="downloadImage"
                      >
                        Download
                      </a>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeRefundOrderModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                style="height:auto; margin-right: 4%"
                outline
                color="success"
              >Save</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
  props: [
    'order_id_fk',
    'takeOrderImageDialog'
  ],

  data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: '#',
      imgResult: [],
      oid: 100,
      facingMode: 'user', // 'user' for front camera, 'environment' for rear camera
      zoom: 1 // Zoom level from 1 to 3
    }
  },

  methods: {
    getImg() {
      console.log(document.getElementById('testImg').files[0])
    },

    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false
        this.isPhotoTaken = false
        this.isShotPhoto = false
        this.stopCameraStream()
      } else {
        this.isCameraOpen = true
        this.createCameraElement()
      }
    },

    createCameraElement() {
      this.isLoading = true

      const constraints = (window.constraints = {
        audio: false,
        video: { facingMode: this.facingMode }
      })

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false
          this.$refs.camera.srcObject = stream
        })
        .catch(() => {
          this.isLoading = false
          alert("May the browser didn't support or there is some errors.")
        })
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks()

      tracks.forEach((track) => {
        track.stop()
      })
    },

    flipCamera() {
      // Toggle between front and rear camera
      this.facingMode = this.facingMode === 'user' ? 'environment' : 'user'

      // Stop current stream and restart with new facing mode
      this.stopCameraStream()
      this.createCameraElement()
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true

        const FLASH_TIMEOUT = 50

        setTimeout(() => {
          this.isShotPhoto = false
        }, FLASH_TIMEOUT)
      }

      this.isPhotoTaken = !this.isPhotoTaken

      const context = this.$refs.canvas.getContext('2d')

      // Clear canvas
      context.clearRect(0, 0, 450, 337.5)

      // Apply zoom by scaling and centering
      context.save()
      const scaledWidth = 450 * this.zoom
      const scaledHeight = 337.5 * this.zoom
      const offsetX = (scaledWidth - 450) / 2
      const offsetY = (scaledHeight - 337.5) / 2

      context.drawImage(this.$refs.camera, -offsetX, -offsetY, scaledWidth, scaledHeight)
      context.restore()
    },

    downloadImage() {
      const download = document.getElementById('downloadPhoto')
      const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
      download.setAttribute('href', canvas)

      // Convert dataUrl to File
      let arr = canvas.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      let file = new File([u8arr], 'filename', { type: mime })

      let formData = new FormData()
      formData.append('order_image', file)
      formData.append('order_id_fk', this.order_id_fk)

      let token = localStorage.getItem('access_token')
      Axios.post('api/order_image', formData, {
        headers: { Authorization: 'Bearer ' + token }
      }).then(response => {
        this.imgResult = response.data.data
      })
    },

    submitForm() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.refundOrder()
        }
      })
    }
  }
}
</script>

<style>
.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;
}

.camera-button {
  margin-bottom: 2rem;
}

.camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
}

.camera-zoom {
  margin: 1rem 0;
  width: 100%;
}

.camera-shoot {
  margin: 1rem 0;
}

.camera-shoot button {
  height: 60px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.camera-shoot button img {
  height: 35px;
  object-fit: cover;
}

.camera-loading {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  min-height: 150px;
  margin: 3rem 0 0 -1.2rem;
}
.camera-loading ul {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 999999;
  margin: 0;
}
.camera-loading .loader-circle {
  display: block;
  height: 14px;
  margin: 0 auto;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  position: absolute;
  width: 100%;
  padding: 0;
}

.camera-loading .loader-circle li {
  display: block;
  float: left;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 0;
  position: relative;
  margin: 0 0 0 4px;
  background: #999;
  animation: preload 1s infinite;
  top: -50%;
  border-radius: 100%;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/takeOrderImage.vue